import { createI18n } from 'vue-i18n'
import { DEFAULT_LANGUAGE } from '@/utils/constants'

// Only import English - other languages loaded on demand via i18n-lazy.js
import enMessages from '@/lang/en/index.js'

const i18n = createI18n({
  // composition API mode - vue-i18n 12 removes the legacy mode entirely;
  // globalInjection keeps $t / $i18n available in options-API components
  legacy: false,
  globalInjection: true,
  locale: localStorage.selectedLanguage || DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages: {
    en: enMessages
  },
  // Suppress warnings for missing translations during lazy load
  missingWarn: false,
  fallbackWarn: false
})

export default i18n
